import { FavouriteDefinition } from 'app/types-shared';
import { transformSelectedReport } from './selected-report';

export const updateFavouriteLayoutAttributes = (
  definition: FavouriteDefinition,
  attributes: {
    [key: string]: string | boolean | number;
  }[],
  layoutType: number,
  layoutTypeContext: number
) => {

  const report = definition.reports.find(r => r.report.v === definition.selectedReport.v);

  const attr = attributes.map(a => {
    const keyAttribute: string | boolean = Object.keys(a)?.[0];
    return {
      layoutTypeId: layoutType,
      layoutTypeContext: a.layoutTypeContext ? Number(a.layoutTypeContext) : layoutTypeContext,
      name: keyAttribute,
      value: a[keyAttribute] as string | boolean
    };
  });

  return transformSelectedReport({
    layoutAttributes: [
      ...(!!report.layoutAttributes && report.layoutAttributes.filter(a => {
        return !attr.some(at => at.layoutTypeId === a.layoutTypeId && at.layoutTypeContext === a.layoutTypeContext
          && at.name === a.name);
      })),
      ...attr
    ]
  })(definition);
};
